import { db } from "../../../config/firebase";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

/* ---------- CATEGORIES ---------- */
const categoryRef = collection(db, "categories");

export const addCategory = async (data) => addDoc(categoryRef, data);
export const getCategories = async () => {
  const snapshot = await getDocs(categoryRef);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
};
export const updateCategory = async (id, data) => {
  const ref = doc(db, "categories", id);
  return updateDoc(ref, data);
};
export const deleteCategory = async (id) => {
  const ref = doc(db, "categories", id);
  return deleteDoc(ref);
};

/* ---------- TESTIMONIALS ---------- */
const testimonialRef = collection(db, "testimonials");

export const addTestimonial = async (data) => addDoc(testimonialRef, data);
export const getTestimonials = async () => {
  const snapshot = await getDocs(testimonialRef);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
};
export const updateTestimonial = async (id, data) => {
  const ref = doc(db, "testimonials", id);
  return updateDoc(ref, data);
};
export const deleteTestimonial = async (id) => {
  const ref = doc(db, "testimonials", id);
  return deleteDoc(ref);
};